// extracted by mini-css-extract-plugin
export var addressFields = "_g6-0";
export var animationContainer = "_g6-1";
export var footer = "_g6-2";
export var lineItems = "_g6-3";
export var modalContent = "_g6-4";
export var orderName = "_g6-5";
export var strong = "_g6-6";
export var warning = "_g6-7";